var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaswordKey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12251_8642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.068 4.47443L15.5548 5.98768M9.79685 11.7456L12.9066 8.63587M12.9066 8.63587L15.1765 10.9057L17.8246 8.25755L15.5548 5.98768M12.9066 8.63587L15.5548 5.98768M9.79685 11.7456C10.1875 12.1311 10.4981 12.59 10.7107 13.096C10.9232 13.602 11.0336 14.1451 11.0355 14.6939C11.0373 15.2427 10.9306 15.7865 10.7214 16.2939C10.5122 16.8013 10.2047 17.2623 9.81663 17.6504C9.42855 18.0385 8.96753 18.346 8.46012 18.5552C7.95272 18.7643 7.40894 18.8711 6.86011 18.8692C6.31128 18.8674 5.76823 18.757 5.26224 18.5444C4.75624 18.3319 4.29729 18.0213 3.91182 17.6306C3.15378 16.8458 2.73433 15.7946 2.74381 14.7035C2.75329 13.6124 3.19095 12.5686 3.96251 11.797C4.73407 11.0255 5.77782 10.5878 6.86893 10.5783C7.96005 10.5689 9.01124 10.9883 9.79609 11.7464L9.79685 11.7456Z",
    stroke: "#262758",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12251_8642"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 24,
    fill: "white",
    transform: "translate(0.257812 0.078125)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaswordKey);
export default __webpack_public_path__ + "static/media/PaswordKey.22774f8fd0e2124c45c5147a42ef5ace.svg";
export { ForwardRef as ReactComponent };